@if (result()) {
  <rt-box variant="default vertical no-padding" margin-bottom>
    <ng-container *ngTemplateOutlet="headerTpl()" />
    <div class="box-header" margin-right margin-left padding-tb-small>
      <rt-heading>
        {{ 'app.interview.edit_quick_evaluation' | translate }}
      </rt-heading>
      <rt-group layout-justify-flex-end margin-right-small-xx>
        <rt-icon-button (click)="cancel()" variant="plain" shape="square" iconName="close" />
      </rt-group>
    </div>
    <rt-divider />
    <div class="box-body" padding>
      <rt-interview-summary
        [parentForm]="form"
        [useRedactor]="true"
        [container]="false"
        [assignedPlacement]="assignedPlacement()"
        [hasProtectedControls]="true"
        (rateChange)="onRateChange()"
      />
    </div>
    <rt-divider />
    <div class="box-footer" padding-right padding-tb-small>
      <rt-group layout-flex-1 margin-left>
        <rt-button [loading]="state.loading" (click)="delete()" variant="plain">
          <rt-icon name="delete" size="medium" margin-right-small-xx />
          {{ 'app.interview.delete' | translate }}
        </rt-button>
      </rt-group>
      <rt-group>
        <rt-button [loading]="state.loading" (click)="cancel()" variant="plain" margin-right-small>
          {{ 'app.interview.cancel' | translate }}
        </rt-button>
        <rt-button
          [loading]="state.loading"
          [disabled]="form.invalid || (form.pristine && !cachedEvaluationForm)"
          (click)="clearEmptyHtmlAndSave()"
          variant="primary"
        >
          {{ 'app.common.save' | translate }}
        </rt-button>
      </rt-group>
    </div>
  </rt-box>
}
